import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Services from "../pages/services/page";
import Contact from "../pages/contact/page";
import Testimonials from "../pages/testimonials/page";
import PersonalTraining from "../pages/personal-training/page";
import OnlineTraining from "../pages/online-training/page";
import NutritionalCoaching from "../pages/nutritional-coaching/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <About /> },
  { path: "/services", element: <Services /> },
  { path: "/contact", element: <Contact /> },
  { path: "/testimonials", element: <Testimonials /> },
  { path: "/personal-training", element: <PersonalTraining /> },
  { path: "/online-training", element: <OnlineTraining /> },
  { path: "/nutritional-coaching", element: <NutritionalCoaching /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
